export const proposalStateKey = (accountId, userId) =>
  `talkvia:proposals:${accountId}:${userId}`;

export const readProposalState = (storage, key) => {
  try {
    const saved = JSON.parse(storage.getItem(key) || 'null');
    if (!saved?.filters || typeof saved.filters !== 'object') return null;
    const invalidDate = ['date_start', 'date_end'].some(field => {
      const value = saved.filters[field];
      return (
        value &&
        (!/^\d{4}-\d{2}-\d{2}$/.test(value) ||
          Number.isNaN(new Date(`${value}T00:00:00`).getTime()))
      );
    });
    if (invalidDate) return null;
    return saved;
  } catch {
    return null;
  }
};

export const writeProposalState = (storage, key, state) => {
  try {
    storage.setItem(key, JSON.stringify(state));
  } catch {
    /* Keep the screen usable when storage is unavailable. */
  }
};
